import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { authStatuses } from '../util/constants';
import { LogInScreen } from '../LogInScreen';

const mapStateToProps = ({
   appData: {
      userData: { status },
   },
}) => ({
   loggedIn: status === authStatuses.authenticated,
});

const Login = connect(mapStateToProps)(({ loggedIn }) =>
   loggedIn ? <Navigate to="/app/dashboard" replace /> : <LogInScreen />
);

export { Login };
